import React from "react";
import "./ButtonSvg.css";

interface ButtonSvgProps {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void; // optional onClick
}

const ButtonSvg: React.FC<ButtonSvgProps> = ({ icon, label, onClick }) => {
  return (
    <div
      className="button_svg"
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      {icon}
      <p>{label}</p>
    </div>
  );
};

export default ButtonSvg;
